import { DATA_SOURCE_TYPES } from '../../../../constants'

export const mockFilesWithPCIData = {
  widget: {
    id: '1',
    name: 'PCI Files Data',
    instancesInFilesCount: 14500,
    datasources: [
      {
        id: '1',
        name: 'Google Drive',
        type: DATA_SOURCE_TYPES.gdrive,
        objectsCount: 5200
      },
      {
        id: '2',
        name: 'SharePoint',
        type: DATA_SOURCE_TYPES.sharePoint,
        objectsCount: 3800
      },
      {
        id: '3',
        name: 'OneDrive',
        type: DATA_SOURCE_TYPES.oneDrive,
        objectsCount: 2800
      },
      {
        id: '4',
        name: 'AWS S3',
        type: DATA_SOURCE_TYPES.aws,
        objectsCount: 1500
      },
      {
        id: '5',
        name: 'Slack',
        type: DATA_SOURCE_TYPES.slack,
        objectsCount: 800
      },
      {
        id: '6',
        name: 'Jira',
        type: DATA_SOURCE_TYPES.jira,
        objectsCount: 300
      },
      {
        id: '7',
        name: 'Outlook',
        type: DATA_SOURCE_TYPES.outLook,
        objectsCount: 50
      },
      {
        id: '8',
        name: 'Teams',
        type: DATA_SOURCE_TYPES.teams,
        objectsCount: 50
      }
    ]
  }
}

export const mockEmptyFilesWithPCIData = {
  totalAttributeInstances: 0,
  datasources: {
    count: 0,
    edges: []
  }
}

export const mockPCISharedWithPartnersData = {
  widget: {
    id: '1',
    name: 'PCI Data Shared',
    partnersCount: 8,
    entitiesCountSharedWithPartners: 45,
    objectsSharedWithPartnerCount: 12500,
    partners: [
      {
        id: '1',
        name: 'Partner A',
        objectsCount: 3200
      },
      {
        id: '2',
        name: 'Partner B',
        objectsCount: 2800
      },
      {
        id: '3',
        name: 'Partner C',
        objectsCount: 2100
      },
      {
        id: '4',
        name: 'Partner D',
        objectsCount: 1800
      },
      {
        id: '5',
        name: 'Partner E',
        objectsCount: 1200
      },
      {
        id: '6',
        name: 'Partner F',
        objectsCount: 800
      },
      {
        id: '7',
        name: 'Partner G',
        objectsCount: 400
      },
      {
        id: '8',
        name: 'Partner H',
        objectsCount: 200
      }
    ],
    dataShareWithPartnersByDatasource: [
      {
        datasourceName: 'Google Drive',
        datasourceType: DATA_SOURCE_TYPES.gdrive,
        datasourceId: '1',
        objectsCount: 5200
      },
      {
        datasourceName: 'SharePoint',
        datasourceType: DATA_SOURCE_TYPES.sharePoint,
        datasourceId: '2',
        objectsCount: 3800
      },
      {
        datasourceName: 'OneDrive',
        datasourceType: DATA_SOURCE_TYPES.oneDrive,
        datasourceId: '3',
        objectsCount: 2800
      },
      {
        datasourceName: 'AWS S3',
        datasourceType: DATA_SOURCE_TYPES.aws,
        datasourceId: '4',
        objectsCount: 700
      }
    ]
  }
}

export const mockPCIAccessRelatedData = {
  widget: {
    id: '1',
    name: 'PCI Access Related Data',
    openAccessObjectsCount: 12500,
    excessAccessObjectsCount: 3200,
    externallySharedCount: 850,
    datasourcesWithOpenAccessCount: [
      {
        datasourceId: 'gdrive-1',
        datasourceName: 'Google Drive',
        datasourceType: DATA_SOURCE_TYPES.gdrive,
        objectsCount: 5200
      },
      {
        datasourceId: 'sp-1',
        datasourceName: 'SharePoint',
        datasourceType: DATA_SOURCE_TYPES.sharePoint,
        objectsCount: 3800
      },
      {
        datasourceId: 'od-1',
        datasourceName: 'OneDrive',
        datasourceType: DATA_SOURCE_TYPES.oneDrive,
        objectsCount: 2800
      },
      {
        datasourceId: 'aws-1',
        datasourceName: 'AWS S3',
        datasourceType: DATA_SOURCE_TYPES.aws,
        objectsCount: 700
      },
      {
        datasourceId: 'slack-1',
        datasourceName: 'Slack',
        datasourceType: DATA_SOURCE_TYPES.slack,
        objectsCount: 450
      },
      {
        datasourceId: 'jira-1',
        datasourceName: 'Jira',
        datasourceType: DATA_SOURCE_TYPES.jira,
        objectsCount: 300
      },
      {
        datasourceId: 'outlook-1',
        datasourceName: 'Outlook',
        datasourceType: DATA_SOURCE_TYPES.outLook,
        objectsCount: 150
      },
      {
        datasourceId: 'teams-1',
        datasourceName: 'Teams',
        datasourceType: DATA_SOURCE_TYPES.teams,
        objectsCount: 100
      }
    ],
    datasourcesWithExcessAccessCount: [
      {
        datasourceId: 'gdrive-1',
        datasourceName: 'Google Drive',
        datasourceType: DATA_SOURCE_TYPES.gdrive,
        objectsCount: 1500
      },
      {
        datasourceId: 'sp-1',
        datasourceName: 'SharePoint',
        datasourceType: DATA_SOURCE_TYPES.sharePoint,
        objectsCount: 800
      },
      {
        datasourceId: 'od-1',
        datasourceName: 'OneDrive',
        datasourceType: DATA_SOURCE_TYPES.oneDrive,
        objectsCount: 600
      },
      {
        datasourceId: 'aws-1',
        datasourceName: 'AWS S3',
        datasourceType: DATA_SOURCE_TYPES.aws,
        objectsCount: 200
      },
      {
        datasourceId: 'slack-1',
        datasourceName: 'Slack',
        datasourceType: DATA_SOURCE_TYPES.slack,
        objectsCount: 100
      }
    ]
  }
}

export const mockPCIDatabasesData = {
  widget: {
    id: '1',
    name: 'PCI Databases Data',
    blobInstancesCount: 8500,
    databaseStats: {
      totalTablesCount: 245,
      totalColumnsCount: 12800,
      totalDatabasesCount: 42,
      databases: [
        {
          id: '1',
          name: 'CustomerDB',
          columnsCount: 3200,
          datasourceId: 'ds-1',
          datasourceType: DATA_SOURCE_TYPES.mySql
        },
        {
          id: '2',
          name: 'PaymentProcessing',
          columnsCount: 2800,
          datasourceId: 'ds-2',
          datasourceType: DATA_SOURCE_TYPES.mssql
        },
        {
          id: '3',
          name: 'UserAccounts',
          columnsCount: 2100,
          datasourceId: 'ds-3',
          datasourceType: DATA_SOURCE_TYPES.postgreSql
        },
        {
          id: '4',
          name: 'TransactionLogs',
          columnsCount: 1800,
          datasourceId: 'ds-4',
          datasourceType: DATA_SOURCE_TYPES.bigQuery
        },
        {
          id: '5',
          name: 'BillingSystem',
          columnsCount: 1500,
          datasourceId: 'ds-5',
          datasourceType: DATA_SOURCE_TYPES.mySql
        },
        {
          id: '6',
          name: 'AuditTrail',
          columnsCount: 1200,
          datasourceId: 'ds-6',
          datasourceType: DATA_SOURCE_TYPES.mssql
        },
        {
          id: '7',
          name: 'SecurityLogs',
          columnsCount: 800,
          datasourceId: 'ds-7',
          datasourceType: DATA_SOURCE_TYPES.snowflake
        }
      ]
    }
  }
}

export const mockPCIFileDistribution = {
  data: {
    totalFiles: 14500,
    datasourcesCount: 4,
    widgetData: [
      {
        id: '1',
        name: 'Credit Card Numbers',
        objectCount: 5200
      },
      {
        id: '2',
        name: 'CVV Codes',
        objectCount: 3800
      },
      {
        id: '3',
        name: 'Expiration Dates',
        objectCount: 2800
      },
      {
        id: '4',
        name: 'Cardholder Names',
        objectCount: 1500
      },
      {
        id: '5',
        name: 'Track Data',
        objectCount: 800
      },
      {
        id: '6',
        name: 'PIN Blocks',
        objectCount: 300
      }
    ]
  }
}

export const mockFilesDistributionByTime = {
  data: [
    { timeRange: 'LAST_3_MONTHS', count: 4500 },
    { timeRange: 'LAST_6_MONTHS', count: 3200 },
    { timeRange: 'LAST_1_YEAR', count: 2800 },
    { timeRange: 'LAST_3_YEARS', count: 1800 },
    { timeRange: 'MORE_THAN_3_YEARS', count: 2200 }
  ]
}
